export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getToken = () => localStorage.getItem("gativan_token");
export const setToken = (t) => localStorage.setItem("gativan_token", t);
export const clearToken = () => localStorage.removeItem("gativan_token");

export const authHeaders = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const withAuth = () => ({ headers: authHeaders(), withCredentials: true });
